import { useState } from 'react';

import classes from './Property.module.css';

import { strToArray } from '../../utils/utils';
import MaterialAddIcon from '../Core/MaterialIcons/MaterialAddIcon';
import MaterialRemoveIcon from '../Core/MaterialIcons/MaterialRemoveIcon';
import ImagesComponent from '../ShortlistComponent/ImagesComponent';

const PropertyOption = ({ option, index, addToTourList, removeFromTourList }) => {
  const [isSelected, setIsSelected] = useState(option?.isSelectedForTour);

  const addToTour = () => {
    setIsSelected(!isSelected);
    addToTourList(option.id);
  };

  const deleteFromTour = () => {
    setIsSelected(!isSelected);
    removeFromTourList(option.id);
  };

  const preText = 'https://d1muf25xaso8hp.cloudfront.net/https%3A%2F%2F';
  const images1 = [];

  option.customImages &&
    option.customImages.map((image) =>
      images1.push({
        original: preText + encodeURI(image).split('//')[1],
      }),
    );

  return (
    <div className={classes.property}>
      <div className={classes.propertyName}>
        {' '}
        {index}. {option.name}{' '}
      </div>
      <div className={classes['images_wrapper']}>
        <ImagesComponent images={strToArray(option.images)} />
      </div>

      <div className={classes.propertyAddress}> {option.address && option.address.address}</div>

      {!option.isSelectedForTour ? (
        <div className={classes.btn} onClick={addToTour}>
          <span>
            <MaterialAddIcon></MaterialAddIcon>
          </span>
          <span> Add </span>
        </div>
      ) : (
        <div className={classes.shortlistedBtn} onClick={deleteFromTour}>
          <span>
            <MaterialRemoveIcon></MaterialRemoveIcon>
          </span>
          <span> Remove</span>
        </div>
      )}
    </div>
  );
};

export default PropertyOption;
